var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-tags-wrapper"},[_c('Tags',{attrs:{"field":"colls"}}),_c('Tags',{attrs:{"field":"publishers"}}),_c('Tags',{attrs:{"field":"dcolls"}}),_c('Tags',{attrs:{"field":"include"}}),_c('Tags',{attrs:{"field":"types"}}),_c('Tags',{attrs:{"field":"tags"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }